import {
  InterventionHistoryActions,
  InterventionHistoryActionTypes,
} from '../actions/intervention-history.actions';
import { createFeatureSelector } from '@ngrx/store';
import { QueryParamsModel } from '../../../../core/_base/crud';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { InterventionHistory } from '../models/intervention-history.model';

export interface InterventionHistoryState extends EntityState<InterventionHistory> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedInterventionHistoryId: number;
  lastCreatedInterventionHistory: InterventionHistory;
  lastQuery: QueryParamsModel;
  showInitWaitingMessage: boolean;
  latestSuccessfullAction: any;
  error: any | null;
}

export const adapter: EntityAdapter<InterventionHistory> =
  createEntityAdapter<InterventionHistory>();

export const initialInterventionHistoryState: InterventionHistoryState = adapter.getInitialState({
  interventionHistoryForEdit: null,
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  lastCreatedInterventionHistoryId: undefined,
  lastCreatedInterventionHistory: undefined,
  lastQuery: new QueryParamsModel({}),
  showInitWaitingMessage: true,
  error: null,
  latestSuccessfullAction: null,
});

export function interventionHistoryReducer(
  state = initialInterventionHistoryState,
  action: InterventionHistoryActions,
): InterventionHistoryState {
  switch (action.type) {
    case InterventionHistoryActionTypes.InterventionHistoryPageToggleLoading: {
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedInterventionHistoryId: undefined,
      };
    }
    case InterventionHistoryActionTypes.InterventionHistoryActionToggleLoading: {
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    }
    case InterventionHistoryActionTypes.InterventionHistoryPageLoaded: {
      return adapter.addMany(action.payload.interventionHistory, {
        ...initialInterventionHistoryState,
        totalCount: action.payload.totalCount,
        listLoading: false,
        lastQuery: action.payload.page,
        showInitWaitingMessage: false,
      });
    }
    case InterventionHistoryActionTypes.ThrowInterventionHistoryError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case InterventionHistoryActionTypes.ClearInterventionHistoryErrors: {
      return {
        ...state,
        error: null,
      };
    }
    case InterventionHistoryActionTypes.FireInterventionHistorySuccess: {
      return {
        ...state,
        latestSuccessfullAction: { action_type: action.payload.action_type },
        error: null,
      };
    }
    default:
      return state;
  }
}

export const getInterventionHistoryState =
  createFeatureSelector<InterventionHistory>('interventionHistory');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
